import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const [activeState, setActiveState] = useState<boolean>(false)
    const {t} = useTranslation()
    return(
        <>
        <footer>
            <div>
                <span></span>
                <div>
                    <span>{t("footer_1")}</span>
                    <span>{t("footer_2")}</span>
                    <span>{t("footer_3")}</span>
                </div>
                <div>
                    <span>TEL : +82-61-724-8757~8</span>
                    <span>FAX : +82-61-724-2566</span>
                    <span>E-MAIL : hdme8757@hanmail.net</span>
                </div>
                <div>
                    <p>COPYRIGHT © HYUNDAI EN-TECH INC. ALL RIGHTS RESERVED.</p>
                    
                    <div className={activeState ? 'active' : ''}>
                        <span onClick={()=>setActiveState(prev => !prev)}>{t("footer_4")}</span>
                        <div>
                            <div>
                                <span>관련 사이트 01</span>
                                <span>관련 사이트 02</span>
                                <span>관련 사이트 03</span>
                            </div>
                        </div>
                    </div>
                    {/* <!-- 토글 active클래스 --> */}
                </div>
            </div>
        </footer>
        </>
    )
}
export default Footer;